document.addEventListener('DOMContentLoaded', function () {
  var btn = document.getElementById('custom_chat_btn');
  if (btn) {
    btn.addEventListener('click', function () {
      if (window.tidioChatApi) {
        tidioChatApi.open();
      } else {
        console.error('Tidio Chat API not loaded.');
      }
    });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('scroll', function () {
    var scrollThreshold = window.innerHeight * 0.2;
    var stickyCheckout = document.querySelector('.sticky-checkout');
    if (!stickyCheckout) return;
    if (window.scrollY > scrollThreshold) {
      stickyCheckout.classList.add('active');
    } else {
      stickyCheckout.classList.remove('active');
    }
  });
});

/* === Engraving Text Field ===
   Shows when a variant title contains "With back engraving".
   Saves the value as line_item.properties[Engraving Text] on cart submit. */
(function(){
  if (!/\/products\//.test(window.location.pathname)) return;
  var ID = 'cro-engraving-wrap';
  var INPUT_NAME = 'properties[Engraving Text]';
  var STORE_KEY = 'cro-eng-val';

  function getVarTxt() {
    var p = [];
    document.querySelectorAll('fieldset input[type="radio"]:checked, variant-radios input[type="radio"]:checked').forEach(function(r){
      if (r.value) p.push(r.value);
    });
    document.querySelectorAll('variant-selects select option:checked, fieldset select option:checked').forEach(function(o){
      if (o.value) p.push(o.textContent || o.value);
    });
    return p.join(' / ');
  }

  function needs() {
    var t = getVarTxt();
    if (/without\s*back\s*engraving|without\s*engraving/i.test(t)) return false;
    return /with\s*back\s*engraving|with\s*engraving/i.test(t);
  }

  function isEngravable() {
    var txt = document.body.textContent || '';
    return /with\s+back\s+engraving|without\s+back\s+engraving|with\s+engraving|without\s+engraving/i.test(txt);
  }

  function inject() {
    if (!isEngravable()) return;
    if (document.getElementById(ID)) return;
    var form = document.querySelector('form[action*="/cart/add"], product-form form');
    if (!form) return;
    var anchor = form.querySelector('.product-form__buttons, [class*="product-form__buttons"]') || form.lastElementChild;
    if (!anchor) return;
    var wrap = document.createElement('div');
    wrap.id = ID;
    wrap.style.cssText = 'margin:14px 0 10px;padding:12px 14px;background:#fbe5ec;border:1.5px solid #f4b8cc;border-radius:10px;display:none';
    wrap.innerHTML = '<label for="cro-engraving-input" style="display:block;font-size:13px;font-weight:700;margin-bottom:6px;color:#1a1a1a;letter-spacing:.2px">✨ Engraving Text <span style="color:#c2185b">(required)</span></label>' +
      '<input type="text" id="cro-engraving-input" name="' + INPUT_NAME + '" maxlength="20" placeholder="e.g. Forever Yours, M ♥ J" autocomplete="off" style="width:100%;padding:11px 12px;border:1.5px solid #c2185b;border-radius:8px;font-size:14px;font-family:inherit;box-sizing:border-box;background:#fff;color:#1a1a1a">' +
      '<p style="margin:6px 0 0;font-size:11px;color:#666;line-height:1.4">Max 20 characters. Engraved on the back of the pendant.</p>';
    form.insertBefore(wrap, anchor);
    var input = wrap.querySelector('input');
    try {
      var saved = sessionStorage.getItem(STORE_KEY);
      if (saved) input.value = saved;
    } catch(e) {}
    input.addEventListener('input', function(){
      try { sessionStorage.setItem(STORE_KEY, input.value); } catch(e) {}
    });
  }

  function sync() {
    var wrap = document.getElementById(ID);
    if (!wrap) return;
    var input = wrap.querySelector('input');
    if (needs()) {
      wrap.style.display = 'block';
      if (input) input.required = true;
    } else {
      wrap.style.display = 'none';
      if (input) input.required = false;
    }
  }

  function boot() { inject(); sync(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('change', function(e){
    if (!e.target) return;
    var t = e.target;
    if ((t.matches && t.matches('input[type="radio"], select')) || (t.closest && t.closest('variant-radios, variant-selects, fieldset'))) {
      setTimeout(boot, 50);
    }
  });

  document.addEventListener('shopify:section:load', function(){ setTimeout(boot, 200); });

  setTimeout(boot, 800);
  setTimeout(boot, 2000);
  setTimeout(boot, 5000);
})();
